import api from '../utils/request'

export default {
  // 列表 + 组合查询：department / device_name /
  // expire_date_start / expire_date_end / verify_date_start / verify_date_end / conclusion
  list(params) {
    return api.get('/report-reminder/measurement/', { params })
  },
  // 列表顶部汇总：已过期 / 30 天内到期 / 合计（跟随当前筛选条件，不分页）
  stats(params) {
    return api.get('/report-reminder/measurement/stats/', { params })
  },
  // 新增（含单个 PDF，FormData）
  create(data) {
    return api.post('/report-reminder/measurement/', data)
  },
  // 编辑（含可选 PDF 替换，FormData）
  update(id, data) {
    return api.put(`/report-reminder/measurement/${id}/`, data)
  },
  // 删除：数据库删除记录，并把计量证书 PDF 移入「报告提醒/计量提醒/删除/」文件夹
  delete(id) {
    return api.delete(`/report-reminder/measurement/${id}/`)
  },
  // 归档（重新检定）：移动旧证书到归档目录并按规范命名，更新记录检定日期，存入新证书
  archive(id, data) {
    return api.post(`/report-reminder/measurement/${id}/archive/`, data)
  },
  // 识别报告：上传计量证书 PDF，自动提取字段供表单回填
  // 扫描件需 PDF 渲染 + RapidOCR，多页报告常超过 30s，单独放宽超时到 3 分钟
  extractPdf(data) {
    return api.post('/report-reminder/measurement/extract-pdf/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    })
  },
  // 查看归档记录：列出本条记录在硬盘「归档」文件夹中的历史证书文件
  archiveFiles(id) {
    return api.get(`/report-reminder/measurement/${id}/archive-files/`)
  },
  // 导出计量证书 PDF：按选中的记录 ID + 年份筛选，后端打包成 ZIP 下载
  exportFiles(data) {
    return api.post('/report-reminder/measurement/export-files/', data, {
      responseType: 'blob',
      timeout: 120000,
    })
  },
  // 获取所选记录可导出证书的所有年份（含当前证书年份 + 已归档证书年份），用于导出弹窗动态渲染年份多选框
  availableYears(ids) {
    return api.get('/report-reminder/measurement/available-years/', {
      params: { ids: ids.join(',') },
    })
  },
}
